import { AxiosResponse } from 'axios';
import { takeEvery, all, put, call } from 'redux-saga/effects'
import { getContactTypesApi } from "../../services/contact_type.service"
import actions from "./actions"
import logError from "../../utils/logError";

function* GET_CONTACT_TYPES(){
    try{
        const response: AxiosResponse<any> = yield call(getContactTypesApi);
        if(response){
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    }
    catch (e) { logError("redux/contact_type/sagas/GET_CONTACT_TYPES", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_CONTACT_TYPES),
    ])
}
